<template>
	<v-dialog v-model="dialog" scrollable max-width="300px">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="primary"
				icon
				v-bind="attrs"
				v-on="on"
			>
				{{ user.empresas || 0 }}
			</v-btn>
		</template>
		<v-card>
			<v-card-title>Select Country</v-card-title>
			<v-divider></v-divider>
			<v-card-text style="height: 300px;">
				<v-radio-group v-model="dialogm1" column>
					<v-radio label="Bahamas, The" value="bahamas"></v-radio>
					<v-radio label="Bahrain" value="bahrain"></v-radio>
					<v-radio label="Bangladesh" value="bangladesh"></v-radio>
					<v-radio label="Barbados" value="barbados"></v-radio>
					<v-radio label="Belarus" value="belarus"></v-radio>
					<v-radio label="Belgium" value="belgium"></v-radio>
					<v-radio label="Belize" value="belize"></v-radio>
					<v-radio label="Benin" value="benin"></v-radio>
					<v-radio label="Bhutan" value="bhutan"></v-radio>
					<v-radio label="Bolivia" value="bolivia"></v-radio>
					<v-radio label="Bosnia and Herzegovina" value="bosnia"></v-radio>
					<v-radio label="Botswana" value="botswana"></v-radio>
					<v-radio label="Brazil" value="brazil"></v-radio>
					<v-radio label="Brunei" value="brunei"></v-radio>
					<v-radio label="Bulgaria" value="bulgaria"></v-radio>
					<v-radio label="Burkina Faso" value="burkina"></v-radio>
					<v-radio label="Burma" value="burma"></v-radio>
					<v-radio label="Burundi" value="burundi"></v-radio>
				</v-radio-group>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
				<v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {

	name: 'GestorEmpresas',
	props: {
		user: {
			type: Object, // String, Number, Boolean, Function, Object, Array
			required: true
		}
	},
	data () {
		return {

		}
	},
	methods: {
	  save: async function() {
	    
	  }
	}
}
</script>

<style lang="css" scoped>
</style>